import { call, delay, put, takeLatest } from "redux-saga/effects";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";
import {
  PickupRequestSheetActionTypes,
  PickupRequestSheetActions,
} from "../../../actionTypes/operations/pickupRequestSheetTypes";
import { createPickupRequestSheetApi, editPickupRequestSheetByIdApi, getPickupRequestSheetByIdApi, getPickupRequestSheetListApi } from "../../requests/operations/pickupRequestSheetRequests";
import { setPickupRequestSheetDataById, setPickupRequestSheetList, setPickupRequestSheetListCount } from "../../../actions/operations/pickupRequestSheetAction";
import { setPutApiStatus } from "../../../actions/apiStatusActions";

function* getPickupRequestSheetListHandler(action: PickupRequestSheetActionTypes) {
  yield delay(500);
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPickupRequestSheetListApi, action.payload);
    if (data.status) {
      const fallBackData = [
        {
          id: 0,
          prs_date: "2023-08-09T12:00:00.000Z",
          status: "-",
          branch_id: 0,
          prq_list: [0],
          prs_ref_no: "-",
          controller_id: 3,
          type: "-",
          associated_details: {
            driver_name: "-",
            contact_number: "-",
            vehicle_number: "-",
          },
          facility_provider_id: 0,
          facility_provider_code: "-",
          prs_assigned_executive: null,
          created_by: 0,
          createdAt: "2023-08-21T09:00:44.000Z",
          updatedAt: "2023-08-21T09:00:45.000Z",
          driver_id: 0,
          vehicle_id: 0,
          branch: {
            id: 0,
            branch_name: "-",
            address: "-",
          },
          user_created: {
            id: 0,
            name: "-",
          },
          user_controller: {
            id: 0,
            name: "-",
          },
          associated_own_company: null,
          associated_ta_company: null,
          associated_market: {
            id: 0,
            vendor_name: "-",
          },
        },
      ];
      yield put(setPickupRequestSheetList(data?.data?.rows || fallBackData));
      yield put(setPickupRequestSheetListCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* createPickupRequestSheetListHandler(action: PickupRequestSheetActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createPickupRequestSheetApi, action.payload.values);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      
      action.payload?.formikAction?.resetForm()
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editPickupRequestSheetByIdHandler(action: PickupRequestSheetActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editPickupRequestSheetByIdApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));

    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getPickupRequestSheetByIdHandler(action: PickupRequestSheetActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPickupRequestSheetByIdApi, action.payload);
    if (data.status) {
      yield put(setPickupRequestSheetDataById(data?.data));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* pickupRequestSheetSaga() {
  yield takeLatest(PickupRequestSheetActions.GET_PICKUP_REQUEST_SHEET_LIST, getPickupRequestSheetListHandler);
  yield takeLatest(PickupRequestSheetActions.CREATE_PICKUP_REQUEST_SHEET, createPickupRequestSheetListHandler);
  yield takeLatest(PickupRequestSheetActions.GET_PICKUP_REQUEST_SHEET_BY_ID, getPickupRequestSheetByIdHandler);
  yield takeLatest(PickupRequestSheetActions.EDIT_PICKUP_REQUEST_SHEET_BY_ID, editPickupRequestSheetByIdHandler);
}
